import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { Vol5Carousel } from './pages/Vol5Carousel';
import { painVoices, wantVoices } from './data/testimonials';

/*
 * Notificaciones de compra (components/PurchaseNotifications.tsx) apagadas:
 * DPS-33 todavía no tiene compradores reales. Volver a montarlas solo con
 * datos reales de ventas.
 */
export function App({
  view = 'landingPage'
}: {
  view?: 'landingPage' | 'vol5Carousel';
}) {
  if (view === 'vol5Carousel') return <Vol5Carousel data-id="element-0" data-mp="5yhgo69t1c8" />;
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-1" data-mp="4wvvprmowg9">
      <MetaPixel data-id="element-2" data-mp="2zmenq84nlk7i" />
      <main data-id="element-3" data-mp="2zmwggus3xgao">
        <Hero data-id="element-4" data-mp="2zng1ikd20ksx" />
        <SocialProofBar data-id="element-5" data-mp="33mowfsjtyoq2" />
        <PainGrid data-id="element-6" data-mp="33lwzadal4ixo" />
        <Testimonials voices={painVoices} title="You’re not the only one" subtitle="Real words from softball coaches on public coaching forums — and where each problem is already solved inside the pack." background="white" data-id="element-7" data-mp="33nggq77z9011" />
        <ProductReveal data-id="element-8" data-mp="nw2egcoye2u9" />
        <LookInside data-id="element-9" data-mp="nur8q7by6l0i" />
        <Tomes data-id="element-10" data-mp="nvanjf6awtab" />
        <Bonuses data-id="element-11" data-mp="nxwv3et6z8sj" />
        <ValueStack data-id="element-12" data-mp="sudlkfnv5z8s" />
        <Urgency data-id="element-13" data-mp="stubfl4ggf5b" />
        <Pricing data-id="element-14" data-mp="stccggqermtp" />
        <Guarantee data-id="element-15" data-mp="ssstcwp0use3" />
        <Faq data-id="element-16" data-mp="36hwf6uoms18" />
        <Testimonials voices={wantVoices} eyebrow="What good coaches ask for" title="Exactly what coaches say they need" subtitle="The advice coaches give each other most often — already built into every practice." background="cream" data-id="element-17" data-mp="3686fj9n0kvj" />
        <CostOfInaction data-id="element-18" data-mp="85uj9rljzz3t" />
        <Close data-id="element-19" data-mp="85b8cuubmaza" />
      </main>
      <Footer data-id="element-20" data-mp="864djrdmssfb" />
    </div>;
}